<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        title="Termo de Compromisso – LGPD, Segurança da Informação e Sigilo no SUAS"
        centered
        size="xl"
        @hidden="cancelar"
        id="modal-tecnico-accept"
    >
        <load mode="table" v-if="loading" />
        <form v-else @submit.prevent="submit">
            <div class="row px-3 flex-column" style="text-align: justify;">
                <p>Para continuar utilizando os sistemas e recursos disponibilizados pela gestão municipal e pela contratada SUAS FÁCIL, é necessário que você tenha ciência e aceite os termos legais e técnicos que regem o tratamento de dados pessoais, em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD).</p>
                
                <p><b>Acesse o termo completo aqui:</b> <a href="https://docs.google.com/document/d/1fU3kTM0lfXG_NC3WoaqFNzRroVO4rl3A" target="_blank">Abrir Termo de Compromisso.</a></p>

                <p><b>Principais compromissos assumidos ao aceitar o termo:</b></p>
                <ul class="px-4 d-flex flex-column mb-4" style="text-align: justify; gap: 0.5rem;">
                    <li>Manter sigilo absoluto sobre as informações dos usuários atendidos pelo SUAS, incluindo dados pessoais e sensíveis;</li>
                    <li>Tratar dados pessoais apenas com base nas hipóteses legais previstas nos artigos 7º, 11 e 14 da LGPD;</li>
                    <li>Proteger de forma reforçada os dados de crianças e adolescentes, sempre considerando seu melhor interesse;</li>
                    <li>Cumprir os protocolos de segurança na operação dos sistemas: uso individual de senhas, autenticação adequada, não compartilhamento de credenciais e uso exclusivo de dispositivos autorizados;</li>
                    <li>Comunicar imediatamente qualquer incidente de segurança, vazamento ou suspeita de violação de dados, no prazo máximo de 24 horas;</li>
                    <li>Assegurar a guarda correta de documentos físicos e digitais, conforme as normas aplicáveis da política de assistência social.</li>
                </ul>

                <div>
                    <p><b>Declaração de ciência</b></p>
                    <form-checkbox 
                        v-model="tecnico.accept"
                        name="accept"
                        label="Declaro que já tive acesso, li e assinei o termo de compromisso completo."
                        :required="true"
                    />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-success" type="submit">
                        <i class="mdi mdi-check-circle"></i> Confirmar
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    name: "ModalTecnicoAccept",
    data() {
        return {
            loading: false,
            tecnico: [],
            unidades: [],
            unidades_tecnico: [],
            unidade_selected: "",
            dateNow: moment().format("LL"),
            // load_change_unidade: this.$root.load_change_unidade
        };
    },

    mounted() {
        if (this.$store.state.user.accept == 0) {
            this.$bvModal.show("modal-tecnico-accept");
        }
    },
    methods: {
        submit() {
            this.loading = true;
            axios
                .get(
                    `api/dashboard/tecnico/set/accept/${this.unidade_selected}`
                )
                .then((response) => {
                    location.reload();
                    this.cancelar();
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("modal-tecnico-accept");
        },
    },
};
</script>
